export const PRICE_CALENDAR_INTERACTION = 'PRICE_CALENDAR_INTERACTION';
export const PRICE_CALENDAR_INTERACTION_VERSION = '1.0';

export type PriceCalendarInteractionAction =
  'month_dropdown' | 'month_right_arrow' | 'month_left_arrow' | 'day_click' | 'day_click_cheapest';

export type PriceCalendarInteractionPayload = {
  searchId: string;
  productDetailKey: string;
  action: PriceCalendarInteractionAction;
};

export type PriceCalendarInteractionParams = {
  searchId: string;
  productDetailKey: string;
  action: PriceCalendarInteractionAction;
};

export const createPriceCalendarInteractionPayload = ({
  searchId,
  productDetailKey,
  action,
}: PriceCalendarInteractionParams): PriceCalendarInteractionPayload => ({
  searchId,
  productDetailKey,
  action,
});
